import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const featured = testimonials.filter((t) => t.isFeatured);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="inline-block bg-amber-50 text-amber-700 text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full mb-3">
            Testimonials
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-4">
            Loved by 50,000+ Customers
          </h2>
          <p className="text-slate-600 text-base md:text-lg leading-relaxed">
            Real stories from real people who trusted ExpertAdvise for their insurance and financial decisions.
          </p>
        </div>

        {/* Featured Testimonial */}
        <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-3xl p-6 md:p-10 mb-8 md:mb-12 border border-slate-100">
          <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-start">
            <div className="shrink-0">
              <div className={`w-16 h-16 md:w-20 md:h-20 rounded-full ${featured[activeIndex].avatarColor} flex items-center justify-center text-white text-xl md:text-2xl font-bold shadow-lg`}>
                {featured[activeIndex].initials}
              </div>
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm ${
                      i < featured[activeIndex].rating ? "text-amber-400" : "text-slate-300"
                    }`}
                  ></i>
                ))}
                <span className="ml-2 text-sm font-semibold text-slate-700">
                  {featured[activeIndex].insuranceType}
                </span>
              </div>
              <blockquote className="text-base md:text-lg text-slate-700 leading-relaxed mb-5 italic">
                &ldquo;{featured[activeIndex].reviewText}&rdquo;
              </blockquote>
              <div>
                <p className="font-bold text-slate-900 text-sm md:text-base">
                  {featured[activeIndex].name}
                </p>
                <p className="text-sm text-slate-500">{featured[activeIndex].city}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial Selector */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {featured.map((t, idx) => (
            <button
              key={t.id}
              onClick={() => setActiveIndex(idx)}
              className={`flex items-center gap-3 p-3 rounded-xl transition-all text-left ${
                idx === activeIndex
                  ? "bg-primary-50 border-2 border-primary-300 shadow-sm"
                  : "bg-slate-50 border-2 border-transparent hover:bg-slate-100"
              }`}
            >
              <div className={`w-10 h-10 rounded-full ${t.avatarColor} flex items-center justify-center text-white text-sm font-bold shrink-0`}>
                {t.initials}
              </div>
              <div className="min-w-0">
                <p className={`text-xs font-semibold truncate ${idx === activeIndex ? "text-primary-700" : "text-slate-700"}`}>
                  {t.name}
                </p>
                <p className="text-[10px] text-slate-500 truncate">{t.city}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}